import React from 'react';
import { MenuProps } from 'antd';
import { ContactPopover } from 'layouts/Component/ContactPopover';

import { NavigationItemInterface } from 'interfaces/navigationItem.interface';

import { ReactComponent as BellIcon } from 'assets/icons/Bell.svg';
import { ReactComponent as PersonIcon } from 'assets/icons/PersonFill.svg';

export type MenuItem = Required<MenuProps>['items'][number];

export const getTopNavigationItems = (
  isLeadReferent: boolean,
  isLeadOnly: boolean,
): NavigationItemInterface[] => {
  const baseItems: NavigationItemInterface[] = [
    {
      key: '/',
      label: 'Actualités',
    },
  ];

  const trailingItems: NavigationItemInterface[] = [
    {
      key: 'contact',
      icon: <ContactPopover />,
    },
    {
      key: '/mon-compte',
      icon: <PersonIcon />,
    },
    {
      key: 'notifications',
      icon: <BellIcon />,
    },
  ];

  if (isLeadOnly) {
    return [
      ...baseItems,
      { key: '/gestion-leads', label: 'Gestion de leads' },
      {
        key: '/faq',
        label: 'FAQ',
      },
      ...trailingItems,
    ];
  }

  const items: NavigationItemInterface[] = [...baseItems];

  if (isLeadReferent) {
    items.push({ key: '/gestion-leads', label: 'Gestion de leads' });
  }

  if (!isLeadOnly) {
    items.push(
      {
        key: '/calculer-une-prime',
        label: (
          <>
            Simulation & <br /> Soumission de dossier
          </>
        ),
      },
      {
        key: '/generation-document',
        label: 'Générer un document',
      },
      {
        key: '/tableau-de-bord',
        label: 'Tableau de bord',
      },
      {
        key: '/dossiers',
        label: 'Suivi de dossiers',
      },
    );
  }

  items.push(
    {
      key: '/faq',
      label: 'FAQ',
    },
    ...trailingItems,
  );

  return items;
};

export const getBottomNavigationItems = (
  isLeadReferent: boolean,
  isLeadOnly: boolean,
): NavigationItemInterface[] => {
  const items: NavigationItemInterface[] = [
    {
      key: '/',
      label: 'Actualités',
    },
  ];

  if (isLeadReferent) {
    items.push({
      key: '/gestion-leads',
      label: 'Gestion de leads',
    });
  }

  if (!isLeadOnly) {
    items.push(
      {
        key: '/calculer-une-prime',
        label: 'Simulation & Soumission de dossier',
      },
      {
        key: '/generation-document',
        label: 'Générer un document',
      },
      {
        key: '/dossiers',
        label: 'Suivi de dossiers',
      },
      {
        key:
          'https://www.ecologie.gouv.fr/politiques-publiques/' +
          'dispositif-certificats-deconomies-denergie',
        label: 'Réglementation',
        target: '_blank',
      },
    );
  }

  items.push(
    {
      key: '/faq',
      label: 'FAQ',
    },
    {
      key: 'https://www.hellio.com/mentions-legales',
      label: 'Mentions légales',
      target: '_blank',
    },
    {
      key: 'https://www.hellio.com/cgu',
      label: "Conditions générales d'utilisation",
    },
    {
      key: 'https://www.hellio.com/politique-confidentialite',
      label: 'Politique de confidentialité',
    },
  );

  return items;
};
